export default "__VITE_ASSET__leGc47U3__"